export const executiveSoftwareEngineer = {
  id: 'executive-software-engineer',
  version: 2,
  renderer: 'enterprise',
  name: 'Executive Software Engineer',
  layout: 'single-column',
  theme: 'slate-executive',
  persona: ['software', 'backend', 'engineering'],
  atsLevel: 'A+',
  scoreWeights: {
    ats: 45,
    visual: 25,
    executive: 25,
    student: 5
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'projects', 'education', 'skills'],
  components: {
    header: 'header-executive',
    experience: 'experience-executive',
    projects: 'projects-list',
    skills: 'skills-simple-list',
    education: 'education-classic'
  },
  metadata: {
    industry: ['Tech Enterprise', 'Consulting', 'Fortune 500'],
    companies: ['Salesforce', 'Oracle', 'IBM', 'HP', 'Cisco', 'Accenture', 'Microsoft'],
    ats: ['Workday', 'Taleo', 'SuccessFactors'],
    pages: { min: 2, max: 2, preferred: 2 },
    photo: false,
    icons: false,
    columns: 1,
    experienceLevel: ['Senior', 'Lead', 'Executive'],
    careerStage: 'Executive',
    recommendedFor: ['Engineering Managers', 'CTOs', 'VP of Engineering', 'Principal Architects'],
    avoidFor: ['Entry-level Developers', 'Designers', 'Creatives'],
    dna: ['Executive-Traditional', 'ATS-Perfect', 'Serif-Corporate', 'Dignified', 'High-Density'],
    metrics: {
      readingDifficulty: 97,
      scanningSpeed: 96,
      visualAppeal: 84
    },
    hiringManager: {
      firstImpression: "Authoritative, seasoned technical leader with deep corporate experience",
      scanningStyle: "Top-to-bottom reading focusing on budget control, team size, scale, and degrees",
      preferredStructure: "Summary, experience, projects, education, skills",
      dislikes: ["Minimalist design shortcuts", "Overly casual layouts", "Lack of leadership metric detail"]
    },
    strategy: {
      goal: "Establish professional trust and technical authority through a dignified serif single-column layout",
      focus: "Team leadership size, revenue optimization, enterprise system architecture scale",
      avoid: ["Gimmicky design tokens", "Icons", "Over-segmentation"]
    },
    psychology: {
      coreTraits: ["Trust", "Authority", "Corporate alignment", "Technical leadership"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Use executive, business-aligned terminology. Highlight budget responsibilities, cross-functional collaboration, mentorship, and enterprise architecture decisions.",
      rewriteStyle: "Formal, leadership-focused, highly structured"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'projects', 'education', 'skills']
      },
      overrides: {
        '--font-family-primary': 'Georgia, serif',
        '--spacing-margin': '24px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.08em',
    '--heading-weight': '800',
    '--border-thickness-heading': '2px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '24px',
    '--spacing-item-mb': '14px',
    '--spacing-bullet-gap': '6px',
    '--color-text-main': '#2D3748',
    '--color-text-light': '#718096'
  }
};
export default executiveSoftwareEngineer;
